<template>
  <div id="app">
    <Loading :loading="loading"></Loading>
    <router-view></router-view>
  </div>
  
</template>

<script>
import Loading from './components/Loading.vue'

export default {
  name: 'App',
  components: {
    Loading
  },
  data(){

    return {
      loading:true
    }
  },
  mounted () {
    setTimeout(() => {
      this.loading = false;
    }, 100);
  }
}
</script>

<style>

#app {
  height:100%;
}

</style>
